import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaShieldAlt, FaMoneyBillWave, FaCarSide } from 'react-icons/fa';

function Features() {
    return (
        <section id="features" className="py-5 bg-light">
            <Container>
                <h2 className="text-center mb-5" style={{ color: 'var(--primary-color)' }}>
                    ¿Por qué elegir EduDrive?
                </h2>
                <Row className="g-4">
                    <Col md={4} data-aos="zoom-in">
                        <Card className="h-100 text-center border-0 shadow-sm">
                            <Card.Body>
                                <FaShieldAlt size={40} color="#223C58" className="mb-3" />
                                <Card.Title className="fw-bold">Seguridad ante todo</Card.Title>
                                <Card.Text>
                                    Todos los conductores y pasajeros están verificados. Viaja con tranquilidad gracias a nuestra comunidad segura.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4} data-aos="zoom-in" data-aos-delay="100">
                        <Card className="h-100 text-center border-0 shadow-sm">
                            <Card.Body>
                                <FaMoneyBillWave size={40} color="#223C58" className="mb-3" />
                                <Card.Title className="fw-bold">Ahorro garantizado</Card.Title>
                                <Card.Text>
                                    Comparte el costo del viaje con otros estudiantes y reduce tus gastos de transporte diario.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4} data-aos="zoom-in" data-aos-delay="200">
                        <Card className="h-100 text-center border-0 shadow-sm">
                            <Card.Body>
                                <FaCarSide size={40} color="#223C58" className="mb-3" />
                                <Card.Title className="fw-bold">Comodidad</Card.Title>
                                <Card.Text>
                                    Olvídate del estrés del transporte público. Viaja directo, cómodo y acompañado por estudiantes como tú.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Features;
